"use client";

import Swiper, { SwiperSlide } from "@/components/ui/swiper";
import { cn } from "@/lib/utils";
import { Swiper as SwiperType } from "swiper";
import { Fragment, useState } from "react";
import Richtext from "../../Richtext";
import { DirectusImage } from "@/components/DirectusImage";

function CardItem(props: {
  data: {
    title?: string;
    description?: string;
    icon?: string;
    image?: string;
    texts?: {
      text?: string;
    }[];
  };
}) {
  if (props.data?.image) {
    return (
      <div className="flex items-center justify-center rounded-xl bg-[#F5F5F6]">
        <div className="relative h-[168px] w-full p-5 md:h-[300px]">
          <DirectusImage
            className="object-scale-down object-center"
            fill
            id={props.data.image}
            alt={props.data.title ?? ""}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-[300px] flex-col items-center justify-center rounded-xl bg-[#F5F5F6] px-6 py-5 lg:px-12">
      {props.data?.title && (
        <div className="w-full">
          <div className="mb-6 flex w-full items-center justify-between space-x-2 md:mb-8 lg:mb-10">
            <div className="flex flex-1 flex-col">
              {props.data?.title && (
                <div className="text-base font-medium text-[#383838] lg:text-lg">
                  {props.data.title}
                </div>
              )}

              {props.data?.description && (
                <div className="mt-2 text-sm text-[#2C2C2C]">
                  {props.data.description}
                </div>
              )}
            </div>

            {props.data?.icon && (
              <div className="relative h-10 w-10 flex-shrink-0 md:h-16 md:w-16 lg:h-20 lg:w-20">
                <DirectusImage
                  fill
                  id={props.data.icon}
                  alt={props.data.title ?? ""}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <div className="flex flex-col space-y-4">
        {props.data?.texts?.map((el, index) => (
          <div
            key={index}
            className="flex items-start space-x-2 text-sm text-[#383838]">
            <img src="/icons/text.svg" className="flex-shrink-0 pt-1 w-4" alt="" />
            <span>{el.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ReliabilityTerminologyClient(props: {
  data: {
    tabName: string;
    description: string;
    data: {
      title?: string;
      description?: string;
      icon?: string;
      image?: string;
      texts?: {
        text?: string;
      }[];
    }[];
  }[];
}) {
  const [swiper, setSwiper] = useState<SwiperType>();

  const [current, setCurrent] = useState(0);

  return (
    <div>
      <div className="mt-6 flex items-center justify-center gap-x-4 md:mt-8 md:gap-x-8 lg:mt-8 lg:gap-x-12">
        {props.data.map((el, index) => (
          <Fragment key={index}>
            {index !== 0 && (
              <hr className="h-4 w-0 border-l md:h-6 lg:h-8"></hr>
            )}
            <span
              onClick={() => {
                setCurrent(index);
                swiper?.slideToLoop(index);
              }}
              className={cn(
                "select-none text-sm md:text-lg xl:text-xl",
                current !== index &&
                  "cursor-pointer opacity-80 hover:text-primary",
                current === index && "cursor-default font-bold text-primary"
              )}>
              {el.tabName}
            </span>
          </Fragment>
        ))}
      </div>

      <div className="relative w-full">
        <Swiper
          className="mt-4 w-full md:mt-10"
          centeredSlides
          onSwiper={setSwiper}
          allowTouchMove={false}
          autoHeight
          onActiveIndexChange={(swiper) => {
            setCurrent(swiper.realIndex);
          }}>
          {props.data?.map((el, index) => (
            <SwiperSlide key={el.tabName + index}>
              <div>
                <Richtext
                  data={{
                    content: el.description,
                  }}
                />
              </div>

              <div className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-2 lg:gap-10">
                {el.data.map((el, index) => (
                  <CardItem key={index} data={el} />
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
